import { FC } from "react";
import { Avatar, Box, Typography, Tooltip } from "@mui/material";
import { IReview } from "../../../interfaces/Interfaces";

interface ReviewProps {
    review: IReview;
}

export const ReviewAuthorInfo: FC<ReviewProps> = ({ review }) => {

    const localPublishTime = review?.publishTime
        ? new Date(review.publishTime).toLocaleString(undefined, {
            hour12: false,
            dateStyle: "medium",
            timeStyle: "short",
        })
        : "";
    return (
        <Box sx={{ display: "flex", alignItems: "center" }}>
            <Avatar
                src={review?.authorAttribution?.photoUri}
                alt={review?.authorAttribution?.displayName}
                sx={{ width: 24, height: 24, mr: 1 }}
                slotProps={{ img: { referrerPolicy: "no-referrer" } }}
            />
            <Typography variant="caption" color="text.secondary">
                <a
                    href={review?.authorAttribution?.uri}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "inherit" }}
                >
                    {review?.authorAttribution?.displayName}
                </a>{" "}
                •{" "}
                <Tooltip title={localPublishTime}>
                    <span>{review?.relativePublishTimeDescription}</span>
                </Tooltip>
            </Typography>
        </Box>
    );
};
